import { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Menu, X } from 'lucide-react'

const navLinks = [
  { label: 'Çözümler', href: '/#cozumler' },
  { label: 'Modüller', href: '/#moduller' },
  { label: 'Fiyatlar', href: '/#fiyatlar' },
  { label: 'İletişim', href: '#iletisim' },
]

export function LandingNavbar() {
  const [isScrolled, setIsScrolled] = useState(false)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20)
    handleScroll()
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    setMobileMenuOpen(false)
  }, [location.pathname])

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'navbar-glass py-3 shadow-sm'
          : 'bg-white/80 backdrop-blur-md border-b border-primary/8 py-4'
      }`}
    >
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between">

          {/* Logo */}
          <Link to="/" className="flex items-center gap-2.5 group shrink-0" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <div className="w-9 h-9 bg-gradient-to-br from-primary-dark to-primary rounded-xl flex items-center justify-center shadow-md shadow-primary/25 group-hover:scale-105 transition-transform">
              <span className="text-white text-base font-heading font-extrabold">N</span>
            </div>
            <span className="text-xl font-heading font-extrabold" style={{ color: '#1a1a1a' }}>
              Nova<span className="text-primary">Muhasebe</span>
            </span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-sm font-semibold transition-colors"
                style={{ color: '#374151' }}
                onMouseEnter={(e) => (e.currentTarget.style.color = '#ff7851')}
                onMouseLeave={(e) => (e.currentTarget.style.color = '#374151')}
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/login"
              className="text-sm font-semibold px-4 py-2 transition-colors rounded-lg hover:bg-primary/5"
              style={{ color: '#374151' }}
            >
              Giriş Yap
            </Link>
            <Link
              to="/deneme-kayit"
              className="inline-flex items-center justify-center px-5 py-2.5 rounded-xl font-bold text-sm text-white transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5"
              style={{ background: 'linear-gradient(135deg, #ff7851, #ab2d00)' }}
            >
              Demo İnceleyin
            </Link>
          </div>

          {/* Mobile toggle */}
          <button
            className="md:hidden p-2 rounded-lg hover:bg-primary/10 transition-colors"
            style={{ color: '#374151' }}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Menüyü aç"
          >
            {mobileMenuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="absolute top-full left-0 right-0 bg-white border-b border-primary/10 p-4 shadow-xl md:hidden flex flex-col gap-1">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-gray-700 font-medium p-3 hover:bg-primary/5 hover:text-primary rounded-xl transition-colors text-sm"
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <hr className="border-gray-100 my-2" />
          <Link
            to="/login"
            className="text-gray-700 font-semibold p-3 rounded-xl text-center border border-gray-200 hover:border-primary/30 hover:text-primary transition-colors text-sm"
          >
            Giriş Yap
          </Link>
          <Link
            to="/deneme-kayit"
            className="text-white font-bold p-3 rounded-xl text-center text-sm"
            style={{ background: 'linear-gradient(135deg, #ff7851, #ab2d00)' }}
          >
            Ücretsiz Deneyin
          </Link>
        </div>
      )}
    </header>
  )
}
